import { Button } from '@mui/material';
import { usePreviousLocation } from 'components/router-context/router-context.hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const IncPageCancelButton = ({ ...rest }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const previousLocation = usePreviousLocation();

  const handleClick = () => {
    navigate(`${previousLocation.pathname}${previousLocation.search}`);
  };

  return (
    <Button
      variant="outlined"
      data-testid="IncPageCancelButton"
      sx={{ minWidth: 150 }}
      onClick={handleClick}
      {...rest}
    >
      {t('forms.buttons.cancel')}
    </Button>
  );
};
export default IncPageCancelButton;
